import { useMemo } from 'react';
import { SUPPORTED_LANGUAGES, AUTO_LANG } from '@translate-ai/shared';
import { SelectField, type SelectOption } from '@/components/SelectField';
import { useUILocale } from '@/hooks/useUILocale';

interface Props {
  value: string;
  onChange: (v: string) => void;
  allowAuto?: boolean;
  codes?: string[];
  className?: string;
  'aria-label'?: string;
}

export function LangSelect({
  value,
  onChange,
  allowAuto,
  codes,
  className,
  'aria-label': ariaLabel,
}: Props) {
  const locale = useUILocale();
  const options = useMemo<SelectOption<string>[]>(() => {
    const languages = codes
      ? SUPPORTED_LANGUAGES.filter((l) => codes.includes(l.code))
      : SUPPORTED_LANGUAGES;
    const opts: SelectOption<string>[] = languages.map((l) => ({
      value: l.code,
      label: locale === 'ru' ? l.nameRu : l.nameEn,
    }));
    if (allowAuto) {
      opts.unshift({ value: AUTO_LANG, label: locale === 'ru' ? 'Авто' : 'Auto' });
    }
    return opts;
  }, [codes, allowAuto, locale]);

  return (
    <SelectField
      value={value}
      onChange={onChange}
      options={options}
      className={className}
      aria-label={ariaLabel}
    />
  );
}
